import qs from "qs";

export default {
    namespaced: true,
    state: {
        alerts: [],
    },
    mutations: {
        set_alert(state, alert) {
            let id = Date.now();
            state.alerts.unshift({'id': id, 'message': alert.message, 'success': alert.success})
            setTimeout(() => {
                this.commit('alerts/remove_alert', id)
            }, 2000)
        },
        remove_alert(state, id) {
            let index = state.alerts.findIndex((el) => {
                return el.id === id
            })
            if (index >= 0) {
                state.alerts.splice(index, 1)
            }
        }
    },
    actions: {},
    getters: {
        get_alerts: (state) => state.alerts
    }
};